import { render, staticRenderFns } from "./LoadDebts.vue?vue&type=template&id=2523e1b3&scoped=true&"
import script from "./LoadDebts.vue?vue&type=script&lang=js&"
export * from "./LoadDebts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2523e1b3",
  null
  
)

export default component.exports